module.exports = __webpack_public_path__ + "static/media/tas.daa30352.svg";